import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import facebookSrc from '@assets/facebook.svg';
import instagramSrc from '@assets/instagram.svg';
import youtubeSrc from '@assets/youtube.svg';
import twitterSrc from '@assets/twitter.svg';
import linkedinSrc from '@assets/linkedin.svg';

const Wrapper = styled.div`
  display: flex;
  img {
    height: 30px;
    margin-right: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .lastChild {
    margin-right: 0px;
  }
`;

const SocialMedia = () => {
  return (
    <Wrapper>
      <Link
        to={{ pathname: "https://www.facebook.com/bwstiftung" }}
        target="_blank"
      >
        <img src={facebookSrc} alt="facebook logo" />
      </Link>
      <Link
        to={{ pathname: "https://www.instagram.com/bwstiftung" }}
        target="_blank"
      >
        <img src={instagramSrc} alt="instagram logo" />
      </Link>
      <Link
        to={{ pathname: "https://www.youtube.com/user/bwstiftung" }}
        target="_blank"
      >
        <img src={youtubeSrc} alt="youtube logo" />
      </Link>
      <Link to={{ pathname: "https://twitter.com/bwstiftung" }} target="_blank">
        <img src={twitterSrc} alt="twitter logo" />
      </Link>
      <Link
        to={{
          pathname:
            "https://www.linkedin.com/company/baden-w%C3%BCrttemberg-stiftung-ggmbh",
        }}
        target="_blank"
      >
        <img
          className="lastChild"
          src={linkedinSrc}
          alt="linkedin logo"
        />
      </Link>
    </Wrapper>
  );
};

export default SocialMedia;
